"use client";

import { useRef } from "react";
import StoreBox from "../store-box";
import ProfilePage from "./profile-page";
import { useAppDispatch } from "../../../../slice/hooks";
import { useHistoryManager } from "../../../../history/useHistoryManager";
import { setActiveCategory, setCategories } from "../../../../slice/category-slice";
import {
  setAccessPoint,
  setAccessPointId,
  setAccessPoints,
  setOrganisation,
} from "../../../../slice/accessOrg-slice";
import styles from "../index.module.scss";

const ProfileContainer = (props) => {
  const {
    fullUrlPath,
    loginSuccessHandler,
    organisation,
    accessPointId,
    storePath,
    cart,
    navLocation,
  } = props;

  const scrollRef = useRef(null);
  const { navigateTo } = useHistoryManager();
  const dispatch = useAppDispatch();

  return (
    <>
      {navLocation === "marketplace" && (
        <button
          type="button"
          className={styles.convetiMarketplaceProfileLink}
          onClick={() => {
            navigateTo(
              "market-place/stores",
              {
                urlData: {
                  accessPoint: null,
                  accessPoints: [],
                  accessPointId: null,
                  organisation: null,
                },
                onNavigate: (navigate) => {
                  if (navigate) {
                    dispatch(setAccessPointId(null));
                    dispatch(setAccessPoint(null));
                    dispatch(setAccessPoints([]));
                    dispatch(setOrganisation(null));
                    dispatch(setActiveCategory(null));
                    dispatch(setCategories(null));
                  }
                },
              },
              false,
            );
          }}
        >
          Go to marketplace stores
        </button>
      )}
      <StoreBox
        {...props}
        handleLocationChange={() => {}}
        bodyClassName={styles.convetiProfileTarget}
      >
        <div className={styles.convetiProfileContainer} ref={scrollRef}>
          <ProfilePage
            storePath={storePath}
            cart={cart}
            fullUrlPath={fullUrlPath}
            organisation={organisation}
            accessPointId={accessPointId}
            parentScrollRef={scrollRef}
            handleLoginSuccess={loginSuccessHandler}
          />
        </div>
      </StoreBox>
    </>
  );
};

export default ProfileContainer;
